import { graphql } from 'msw';

import { hasValidToken } from '../utils';

export const getCustomerQrr = graphql.query<
    GetCustomerQrrQuery,
    GetCustomerQrrQueryVariables
>('getCustomerQrr', (req, res, ctx) => {
    if (hasValidToken(req, 'publisher')) {
        return res(
            ctx.data({
                getCustomerQrr: 5000,
            }),
        );
    }

    return res();
});
